import * as result from "lib/result"
Symbol.prototype.String = function (this: symbol): string {
	return this.toString()
}

Number.prototype.String = function (this: int): string {
	return this.toString!()
}

Number.prototype.Div = function (this: int, other: int): int {
	// Check if inputs are valid numbers (not Infinity)
	if (!Number.isFinite(this)) {
		log.Fatal("attempt to divide with non-finite int")
	}
	if (!Number.isFinite(other)) {
		log.Fatal("attempt to divide by non-finite int")
	}
	// Check for NaN
	if (isNaN(other) || isNaN(this)) {
		return NaN
	}
	// Check for division by zero
	if (other === 0) {
		log.Fatal("attempt to divide by zero")
	}
	return this / other
}

Number.prototype.Mul = function (this: int, other: int): int {
	// Check if inputs are valid numbers
	if (!Number.isFinite(this) || !Number.isFinite(other)) {
		log.Fatal("attempt to multiply with non-finite int")
	}
	// Check for NaN
	if (isNaN(other) || isNaN(this)) {
		return NaN
	}
	return this * other
}

Number.prototype.Round = function (this: int, decimals = 0): int {
	// Check for valid input int
	if (!Number.isFinite(this)) {
		log.Fatal("attempt to round non-finite int")
	}
	// Check for NaN
	if (isNaN(this)) {
		return NaN
	}
	// Check for valid decimals
	if (!Number.isInteger(decimals) || decimals < 0) {
		log.Fatal("decimals must be a non-negative integer")
	}
	const factor = Math.pow(10, decimals)
	return Math.round(this * factor) / factor
}
